/* eslint-disable prettier/prettier */
import Grid from '@elliemae/ds-grid';
import { DSSkeleton } from '@elliemae/ds-skeleton';
import { memo } from 'react';

export const MILoadingSkeleton = memo(function MILoadingSkeleton({
  hasEncApr,
}: {
  hasEncApr?: boolean;
}) {
  const width = hasEncApr === undefined ? '60px' : hasEncApr ? '96px' : '48px';
  return (
    <Grid width="100%" justifyContent="flex-end">
      <DSSkeleton
        variant="rectangular"
        width={width}
        height="24px"
        data-testid="get-mi-skeleton"
      />
    </Grid>
  );
});
